import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CloseIcon from '@mui/icons-material/Close';
import {
    Box,
    IconButton,
    Paper,
    Popper,
    ToggleButton,
    Tooltip,
} from '@mui/material';
import { ReactElement, useEffect, useRef, useState } from 'react';

type DropdownToggleButtonProps = {
    isSelected: boolean;
    value: string;
    onToggle: () => void;
    icon: ReactElement;
    tooltipTitle: string;
    popperComponent: ReactElement;
    disabled?: boolean;
};

const DropdownToggleButton = ({
    isSelected,
    value,
    onToggle,
    icon,
    tooltipTitle,
    popperComponent,
    disabled = false,
}: DropdownToggleButtonProps) => {
    const [open, setOpen] = useState(false);
    const anchorRef = useRef<HTMLDivElement>(null);

    const handleClick = () => {
        if (!disabled) {
            setOpen((prevOpen) => !prevOpen);
            onToggle();
        }
    };

    useEffect(() => {
        if (!isSelected) setOpen(false);
    }, [isSelected]);

    return (
        <Box position="relative" ref={anchorRef}>
            <ToggleButton
                value={value}
                onClick={handleClick}
                disabled={disabled}
                aria-disabled={disabled}
            >
                <Tooltip title={tooltipTitle}>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px',
                        }}
                    >
                        {icon}
                        <ArrowDropDownIcon
                            sx={{ fontSize: 16 }}
                            color={disabled ? 'disabled' : 'action'}
                        />
                    </Box>
                </Tooltip>
            </ToggleButton>

            <Popper
                sx={{ width: '400px', zIndex: 1000 }}
                open={open && !disabled}
                anchorEl={anchorRef.current}
            >
                <Paper
                    sx={{
                        position: 'absolute',
                        width: '100%',
                        mt: 0.5,
                    }}
                >
                    <IconButton
                        onClick={handleClick}
                        sx={{
                            position: 'absolute',
                            zIndex: 2000,
                            right: 8,
                            top: 8,
                        }}
                        disabled={disabled}
                    >
                        <CloseIcon fontSize="small" />
                    </IconButton>
                    {popperComponent}
                </Paper>
            </Popper>
        </Box>
    );
};

export default DropdownToggleButton;
